export const iconAnimations = {
  hidden: { opacity: 0 },
  showTitle: {
    opacity: 0,
  },
  showIcon: {
    opacity: [0, 1, 1],
    y: [100, 70, 70],
    rotate: [0, 0, 0, 5, -5, 5, -5, 5, 0],
    transition: {
      duration: 1,
      times: [0, 0.1, 0.15, 0.5, 0.6, 0.7, 1],
      ease: 'easeInOut',
    },
  },
  contentSlide: {
    opacity: [1, 0],
    duration: 0.3,
  },
};

export const titleAnimations = {
  hidden: { opacity: 0 },
  showTitle: {
    opacity: [0, 1],
    y: [200, 150],
    transition: {
      duration: 0.5,
    },
  },
  contentSlide: {
    y: [150, 0],
    transition: {
      duration: 0.8,
      times: [0, 0.1, 0.15, 0.5, 0.6, 0.7, 1],
      ease: 'easeInOut',
    },
  },
};

export const contentAnimations = {
  hidden: {
    opacity: 0,
  },
  showTitle: {
    opacity: 0,
  },
  showIcon: {
    opacity: 0,
  },
  contentSlide: {
    opacity: [0, 1],
    y: [140, 0],
  },
};
